module.exports = __webpack_public_path__ + "img/reports.b20e4486.svg";